module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxwYXRoIGZpbGw9IiM1NjhFQzMiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE1IDNDOC4zNzEgMyAzIDguMzcxIDMgMTVzNS4zNzEgMTIgMTIgMTIgMTItNS4zNzEgMTItMTJTMjEuNjI5IDMgMTUgM3ptNS41NDcgMTEuMDg3bC02LjA1NyA1LjcxNWMtLjQ1Ny40LTEuMTQzLjQtMS42LS4wNThsLTMuMDg2LTMuMTQyYy0uNDU3LS40NTgtLjQ1Ny0xLjIgMC0xLjYuNDU4LS40IDEuMi0uNDU4IDEuNiAwbDIuMjg2IDIuMzQyIDUuMjU3LTQuOTE0Yy41MTUtLjM0MyAxLjItLjIyOCAxLjYuMjI5LjM0My40LjM0My45NzEgMCAxLjQyOHoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/machine-statuses/check-icon.svg
// module id = HfmO
// module chunks = 1